import { variables, Flex, Text } from '@bitrise/bitkit';
import { TypeAttribute } from '@trace/types';
import * as d3Scale from 'd3-scale';
import React, { useState, FunctionComponent } from 'react';
import { ATTRIBUTE_NAME_MAP } from '../../constants/Attributes';
import { formatterPercent } from '../../utils/metric/getFormattedValue';
import './AttributeRatio.css';

interface AttributeRatioValue {
  name: string;
  percent: number;
}

interface Props {
  attribute: TypeAttribute;
  values: AttributeRatioValue[];
}

const colorScale = d3Scale
  .scaleLinear<string>()
  .domain([0, 1])
  .range([variables.colorAqua5, variables.colorAqua3]);

const AttributeRatio: FunctionComponent<Props> = (props) => {
  const { attribute, values } = props;
  const [value, setValue] = useState<null | AttributeRatioValue>(null);

  return (
    <Flex direction="vertical" gap="x1" onPointerLeave={() => setValue(null)}>
      <Flex direction="horizontal" gap="x2">
        <Flex grow initial="none">
          <Text config="8" ellipsis size="x2" weight="bold">
            {ATTRIBUTE_NAME_MAP[attribute]}
          </Text>
        </Flex>

        <Flex>
          <Text config="8" textColor="gray-7">
            {formatterPercent((value ? value.percent : values[0].percent) * 100)}
          </Text>
        </Flex>

        <Flex>
          <Text config="8" textColor="gray-7" weight="bold">
            {value ? value.name : values[0].name}
          </Text>
        </Flex>
      </Flex>

      <Flex>
        <Flex borderRadius="x1" direction="horizontal" height="6px" overflow="hidden">
          {values.map(({ name, percent }, index, { length }) => (
            <Flex
              className="AttributeRatio__section"
              key={name}
              onPointerEnter={() => setValue({ name, percent })}
              style={{
                backgroundColor:
                  !value || value.name === name
                    ? colorScale((index + 1) / length)
                    : variables.colorGray3,
              }}
              width={`${percent * 100}%`}
            />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AttributeRatio;
